module.exports = __webpack_public_path__ + "media/images/icons/flags/SC-e0f80ac561befdba9a1abed450478cae.svg";